import React, { useContext, useState } from 'react';
import styled from 'styled-components/macro';
import { userHasPermission } from '../../../authorisation/permission';
import { Expandable } from '../../../shared/Expandable';
import { ExpandControlChevron } from '../../../shared/ExpandControlChevron';
import { FormContext } from '../../../shared/form/Form';
import { FieldContainer, InputContainer } from '../../../shared/form/FormField';
import { CheckboxField } from '../../../shared/form/inputs/CheckboxField';
import { TextArea } from '../../../shared/form/inputs/TextArea';
import { TextAreaField } from '../../../shared/form/inputs/TextAreaField';
import { TextInputField } from '../../../shared/form/inputs/TextInputField';
import { Td } from '../../../shared/Table';
import { TextInput } from '../../../shared/TextInput';
import { spacing02 } from '../../../styling/spacing';
import { UserContext } from '../../../users/UserContext';
import { GuidanceTextTemplate } from './dataForViewOrEditQuoteBillOfMaterialsForm';
import { GuidanceTextFormModel } from './viewOrEditQuoteBillOfMaterialsFormModel';

type Props = {
  fieldName: string;
  guidanceTextFormModel: GuidanceTextFormModel;
  guidanceTextTemplate: GuidanceTextTemplate;
};

export const GuidanceTextField = ({ guidanceTextFormModel, guidanceTextTemplate, ...props }: Props) => {
  const fieldName = (subFieldName: string) => `${props.fieldName}.${subFieldName}`;
  const { isDisabled } = useContext(FormContext);
  const { getUser } = useContext(UserContext);
  const user = getUser();

  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <>
      <Cell>
        <CellContent>
          <ExpandControlChevron isExpanded={isExpanded} onClick={() => setIsExpanded(!isExpanded)} testId="" />
        </CellContent>
      </Cell>
      <Cell>
        <CellContent>
          <CheckboxField name={fieldName('isSelected')} label={null} />
        </CellContent>
      </Cell>
      <Cell>
        <CellContent>{guidanceTextTemplate.displayOrder}</CellContent>
      </Cell>
      <Fields>
        {guidanceTextFormModel.isSelected && guidanceTextFormModel.isCustomised ? (
          <>
            <TextInputField name={fieldName('customTitle')} label={null} />
            <StyledExpandable isExpanded={isExpanded}>
              <TextAreaField name={fieldName('customBody')} label={null} />
            </StyledExpandable>
          </>
        ) : (
          <>
            <FieldContainer>
              <InputContainer>
                <TextInput disabled={true} value={guidanceTextTemplate.title} />
              </InputContainer>
            </FieldContainer>
            <StyledExpandable isExpanded={isExpanded}>
              <FieldContainer>
                <InputContainer>
                  <TextArea disabled={true} value={guidanceTextTemplate.body} />
                </InputContainer>
              </FieldContainer>
            </StyledExpandable>
          </>
        )}
      </Fields>
      <Cell>
        {guidanceTextFormModel.isSelected && (
          <CellContent>
            <CheckboxField
              name={fieldName('isCustomised')}
              label={null}
              disabled={isDisabled && !userHasPermission({ user, permission: 'Edit' })}
            />
          </CellContent>
        )}
      </Cell>
    </>
  );
};

const StyledExpandable = styled(Expandable)`
  ${FieldContainer} {
    padding-top: ${spacing02};
  }
`;

const Cell = styled(Td)`
  vertical-align: top;
  padding: ${spacing02};
`;

const CellContent = styled.div`
  height: 48px;
  display: flex;
  align-items: center;
`;

const Fields = styled(Td)`
  width: 100%;
  padding: ${spacing02};

  ${FieldContainer} {
    margin: 0;
  }
`;
